export const defaultState = () => ({
  commentsEdited: 0,
  pendingUploads: 0,
  userId: null
});

const state = defaultState();

export default state;
